import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function ScrollToSection() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname.slice(1); // Remove leading '/'
    if (path) {
      const element = document.getElementById(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If no path, scroll to inicio
      const element = document.getElementById('inicio');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.pathname]);
  
  return null;
}

function AppContent() {
  return (
    <div className="App">
      <ScrollToSection />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Clients />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppContent />} />
        <Route path="/inicio" element={<AppContent />} />
        <Route path="/nosotros" element={<AppContent />} />
        <Route path="/soluciones" element={<AppContent />} />
        <Route path="/equipo" element={<AppContent />} />
        <Route path="/contacto" element={<AppContent />} />
      </Routes>
    </Router>
  );
}

export default App;